// This is the Home page with navigation cards to Inspection and Training modules
import React from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import companyLogo from '../company-logo/Dynavative-Indo-Veritas-Logo.png';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Container className="mt-5">
      {/* Header Section */}
      <div className="text-center mb-4">
        {/* Company Logo */}
        <img
          src={companyLogo}
          alt="Dynavative Indo Veritas Logo"
          className="company-logo mb-3"
        />
        <h1 className="fw-bold display-5 text-primary mb-2">
          Equipment Inspection System
        </h1>
        <p className="lead text-muted">
          Professional Equipment Inspection and Certification Platform
        </p>
      </div>

      {/* Card Section */}
      <Row className="justify-content-center g-4">
        {/* Inspection Module Card */}
        <Col md={6} lg={5}>
          <Card
            className="h-100 shadow-lg rounded-4 card-hover card-border"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/inspection')}
          >
            <Card.Body className="text-center p-4">
              <div className="mb-3">
                <i className="fas fa-clipboard-check text-primary" style={{ fontSize: '3rem' }}></i>
              </div>
              <Card.Title className="fw-bold fs-4">Inspection Module</Card.Title>
              <Card.Text className="text-muted mt-2">
                Manage equipment inspections, submit forms, and track certification processes.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Training Module Card */}
        <Col md={6} lg={5}>
          <Card
            className="h-100 shadow-lg rounded-4 card-hover card-border"
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/training')}
          >
            <Card.Body className="text-center p-4">
              <div className="mb-3">
                <i className="fas fa-graduation-cap text-success" style={{ fontSize: '3rem' }}></i>
              </div>
              <Card.Title className="fw-bold fs-4">Training Module</Card.Title>
              <Card.Text className="text-muted mt-2">
                  Generate Certificates for the inspectors.
                <br />
                {/* <small className="text-danger fw-bold">(Coming Soon)</small> */}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Equipment Images Section - Horizontal Scrollable */}
      <div className="mt-5">
        <h4 className="text-center mb-3 fw-bold text-secondary">Some of the Equipment We Inspect</h4>
        <div className="equipment-scroll-container">
          <div className="equipment-scroll-wrapper">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((imageNum) => (
              <div key={imageNum} className="equipment-image-item">
                <img
                  src={require(`../equipment-images/${imageNum}.jpg`)}
                  alt={`Equipment ${imageNum}`}
                  className="equipment-image"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style>
        {`
          .company-logo {
            max-width: 300px;
            height: auto;
            display: block;
            margin: 0 auto;
          }
          .card-hover {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .card-hover:hover {
            transform: translateY(-8px);
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          }
          .card-border {
            border: 3px solid #007bff !important;
          }
          .equipment-scroll-container {
            position: relative;
            max-width: 100%;
            overflow: hidden;
            padding: 20px 0;
          }
          .equipment-scroll-wrapper {
            display: flex;
            gap: 20px;
            overflow-x: auto;
            overflow-y: hidden;
            scroll-behavior: smooth;
            padding: 10px;
            scrollbar-width: thin;
            scrollbar-color: #007bff #f1f1f1;
          }
          .equipment-scroll-wrapper::-webkit-scrollbar {
            height: 8px;
          }
          .equipment-scroll-wrapper::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .equipment-scroll-wrapper::-webkit-scrollbar-thumb {
            background: #007bff;
            border-radius: 10px;
          }
          .equipment-scroll-wrapper::-webkit-scrollbar-thumb:hover {
            background: #0056b3;
          }
          .equipment-image-item {
            flex: 0 0 auto;
            position: relative;
            overflow: hidden;
            border-radius: 15px;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .equipment-image-item:hover {
            transform: scale(1.05);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
          }
          .equipment-image {
            width: 200px;
            height: 200px;
            object-fit: cover;
            display: block;
            border-radius: 15px;
          }
        `}
      </style>
    </Container>
  );
};

export default Home;
